//export const DOMAIN = "http://localhost:8080";
export const DOMAIN = "";
export const API_HOST = `${DOMAIN}/api/`;
